import styles from './unified-top-bar-over-legacy.module.css';
import { UnifiedTopBar } from './unified-top-bar';

/**
 * The unified shell's top bar on the routes its frame does not wrap yet (PLT-6767): the entity
 * views, the screener, the internal views. One bar for an opted-in user on every route, over
 * whatever page frame that route happens to have.
 *
 * This reverses what `use-unified-shell-frame-active.ts` used to argue — that a page is wholly in
 * one shell or wholly in the other, and a white strip over the legacy 247px frame would be a third
 * shell nobody designed. *Decided* (Janne, PLT-6767): meeting the dark bar one click off the home
 * views is the worse of the two, because the seam is what a reader notices and the frame underneath
 * is what they are already used to. So the two gates are separate now — `useUnifiedShell` decides
 * which bar, `useUnifiedShellFrameActive` still decides which frame — and the frame catches up view
 * by view on PLT-6734 and its siblings.
 *
 * Inside the frame the bar needs no wrapper at all, because the frame is fixed over the whole
 * viewport and lays the bar out as its first row. Everything this component adds is what stands in
 * for that: see the module for why the bar is pinned here and why the container sits where it does.
 *
 * Desktop only, and the caller is what enforces that — see `root/main/header-maybe.tsx`.
 */
export function UnifiedTopBarOverLegacyFrame() {
  return (
    <div className={styles.root}>
      <div className={styles.fixed}>
        <UnifiedTopBar />
      </div>
      <div className={styles.spacer} />
    </div>
  );
}
